import create from 'zustand';
import { langcode } from '../catalog/common/utils';

const dictFilterList = [
    'TID',
    'hopkins',
    'bod rgya',
    'martin',
    'rangjung',
    'waldo',
    'valby',
    'barron',
    'phuntsok',
    'dag yig',
    'dung dkar',
    'ming mdzod',
    'smon lam',
    'negi',
    'yogacara',
];

export const useDictionaryStore = create((set, get) => ({
    dictionaries: {}, // the selected or active dictionaries
    dictInfo: {}, // the full list of dictionaries keyed on their code with their full information
    dictTabClosed: false,
    parser: 'java', // Not used
    // remove a dictionary from the list of active dictionaries
    removeDictionary: (dictcode) => {
        const dicts = get().dictionaries;
        if (dictcode in dicts) {
            dicts[dictcode].selected = false;
            set((state) => ({
                dictionaries: {
                    ...dicts,
                    [dictcode]: {
                        ...dicts[dictcode],
                        selected: false,
                    },
                },
            }));
        }
    },
    // add a dictionary to the list of active dictionaries
    addDictionary: (dictcode) => {
        const dicts = get().dictionaries;
        if (dictcode in dicts) {
            set((state) => ({
                dictionaries: {
                    ...dicts,
                    [dictcode]: {
                        ...dicts[dictcode],
                        selected: true,
                    },
                },
            }));
        }
    },
    getDictFilterValue: () => {
        const dictionaries = get().dictionaries;
        const selectedDicts = Object.keys(dictionaries).filter(
            (key) => dictionaries[key].selected
        );
        let dfv = 0;
        selectedDicts.forEach((dict, n) => {
            const dind = dictFilterList.indexOf(dict);
            if (dind > -1) {
                dfv += 2 ** dind;
                //console.log(dind, dfv);
            } else {
                // console.log(dict, "not found in list"); higgins, chandra, and maha not found in list.
            }
        });
        return dfv;
    },
    // get all dict info (default) or info for one dict by code
    getDictInfo: (dictcode = 'all') => {
        const dicts = get().dictInfo;
        return dictcode === 'all' ? dicts : dicts[dictcode];
    },
    // Return a list of dictionaries filtered by language
    getDictsByLang: (langcode = 'bod') => {
        const di = get().dictInfo;
        const dictlist = {};
        for (const dkey in di) {
            const thisdict = di[dkey];
            if (thisdict.language === langcode) {
                dictlist[dkey] = thisdict;
            }
        }
        return dictlist;
    },
    getSelectedDicts: () => {
        const dicts = get().dictionaries;
        const seldicts = [];
        for (const [dname, dict] of Object.entries(dicts)) {
            if (dict.selected === true) {
                seldicts.push(dname);
            }
        }
        return seldicts;
    },
    setParser: (ptype) => {
        set((state) => ({
            parser: ptype,
        }));
    },
    setSelectedDicts: (selectedDicts, isObj = false) => {
        console.log('selectedDicts in store', selectedDicts);
        let newdicts;
        if (isObj) {
            newdicts = selectedDicts;
        } else {
            let dicts = get().dictionaries;
            if (Object.keys(dicts).length === 0) {
                dicts = get().dictInfo;
            }
            newdicts = {};
            for (const [dname, dict] of Object.entries(dicts)) {
                newdicts[dname] = {
                    ...dict,
                    selected: selectedDicts.includes(dname),
                };
            }
        }
        set((state) => ({
            dictionaries: newdicts,
        }));
    },
    reset: () => {
        set((state) => ({ dictionaries: {}, dictInfo: {} }));
    },
    setDictionaries: (dicts) => {
        set((state) => ({ dictionaries: dicts }));
    },
    setDictInfo: (alldicts) => {
        if (Array.isArray(alldicts)) {
            const newalldicts = {};
            alldicts.forEach((dict) => {
                newalldicts[dict.code] = dict;
            });
            set((state) => ({ dictInfo: newalldicts }));
        } else if (typeof alldicts === 'object') {
            set((state) => ({ dictInfo: alldicts }));
        } else {
            console.log('Cannot set dict info unknown object type', alldicts);
        }
    },
    showDictionary: (dictcode) => {
        const dicts = get().dictionaries;
        if (Object.keys(dicts).length === 0 && dicts.constructor === Object) {
            return true;
        }
        if (dictcode in dicts) {
            return dicts[dictcode].selected;
        }
    },
    setDictTabClosed: (tab) => {
        set((state) => ({
            dictTabClosed: !!tab,
        }));
    },
}));
